
import * as angular from 'angular';

import { IwidgetIntervalHelperService } from '../../services';
import { WidgetValuesReadConfiguration, IBindable } from '../../models';
import { WidgetWithErrors, IMaximizable, IdataWidget } from '../../widgets';
import { Helper } from '../../common';
import { IExportable, ILogbookSelection } from '../../widgets/models/interfaces';
import { TagsTrendConfiguration } from './tagsTrend.configuration';
import { IGetReadConfiguration } from '../models/IGetReadConfiguration';
import { TagsTrendWidgetDefinition as definition } from '../../widgets/widgets.definition.index';

export class TagsTrendWidget extends WidgetWithErrors implements IExportable, IMaximizable, IdataWidget, ILogbookSelection, IGetReadConfiguration {
    baseType = definition.baseType;
    col = 0;
    configuration: TagsTrendConfiguration;
    guid: string;
    hasExtendedProperties = true;
    highlights = definition.highlights;
    icon = definition.icon;
    isDisabledMaximized = false;
    isExportable = true;
    isMaximizable = true;
    isMaximized = false;
    isPinnable = true;
    isSelectingLogbook = false;
    isZoomable = true;
    name = definition.title;
    row = 0;
    sizeX = 6;
    sizeY = 18;
    type = definition.type;

    constructor(
        private _$q: ng.IQService,
        private _$translate: ng.translate.ITranslateService,
        intervalHelper: IwidgetIntervalHelperService
    ) {
        super(intervalHelper);
        this.guid = Helper.getGuid();
        this.configuration = new TagsTrendConfiguration();
    }

    exportToCsv(): angular.IPromise<void> {
        return this._$q.when();
    }

    getSeriesGuids(): string[] {
        return this.configuration.series.map(d => d.guid);
    }

    getReadConfiguration(beginDate: string, endDate: string): WidgetValuesReadConfiguration {
        return this.getReadConfigurationBase(beginDate, endDate, this.configuration.series, this.configuration,
            this.configuration.aggregation,
            false, false, false, false, !this.configuration.hideMissing, null, this.configuration.showAlarms,
            this.configuration.options.variableTypeGuid,
            this.configuration.options.unitGuid);
    }

    getReadConfigurations(beginDate: string, endDate: string): WidgetValuesReadConfiguration[] {
        return [this.getReadConfiguration(beginDate, endDate)];
    }

    private getSeriesListAsync(): angular.IPromise<IBindable[]> {
        let result = [];
        if (this.configuration && this.configuration.series) {
            result = this.configuration.series.map(d => {
                return {
                    guid: d.guid,
                    originalGuid: d.guid,
                    value: d.value,
                    relativePath: d.relativePath,
                    isBoundToGroup: d.isBoundToGroup,
                    rawInformation: d.rawInformation
                };
            });
        }
        return this._$q.when(result);
    }

    getReadConfigurationAsync(): angular.IPromise<WidgetValuesReadConfiguration> {
        return this.getSeriesListAsync()
            .then(data => {
                const hasQuality = false;
                const hasMissingRanges = true;
                const hasContext = false;
                const hasTendency = false;
                const hasTarget = false;
                const aggregation = this.configuration.aggregation;
                return this.createConfiguration(data, aggregation, hasQuality, hasMissingRanges, hasContext,
                    hasTendency, hasTarget);
            });
    }

}